import Vue from "vue";
import VueRouter from "vue-router";
import isMobile from "ismobilejs";
import store from "@/store";
import * as cognito from "../utils/cognito";
import Login from "../views/Login";
import Mobile from "../views/Mobile";
import Dashboard from "../views/Dashboard";
import MobileCameraMonitor from "../views/MobileCameraMonitor";
import { isPrivateMode, isPublicMode } from "../utils/common";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/mobile",
    name: "Mobile",
    component: Mobile
  },
  {
    path: "/mobile-camera-monitor",
    name: "MobileCameraMonitor",
    component: MobileCameraMonitor
  }
];

const router = new VueRouter({
  mode: "hash",
  routes
});

router.beforeResolve(async (to, from, next) => {
  const isPC = isMobile().any !== true;

  if (to.path === "/login") {
    if (isPublicMode) {
      next(isPC ? "/" : "/mobile");
    } else {
      next();
    }
    return;
  }

  if (isPC === false && to.path === "/") {
    next({
      path: "/mobile"
    });
    return;
  }

  try {
    if (isPrivateMode) {
      const session = await cognito.isAuthenticated();
      const token = session.idToken.jwtToken;
      const user = Object.assign({}, session.idToken.payload);
      user.token = token;
      user.id = user["cognito:username"];
      if (user.name === undefined) {
        user.name = user.id;
      }
      console.log(user.id);
      store.commit("SET_COGNITO_USER_INFO", user);
    } else {
      cognito.signout();
    }
    store.commit("SET_IS_NAVIGATION", isPC);
    store.commit("SET_IS_RIGHT_NAV", isPC);
    next();
  } catch (error) {
    console.log(error);
    if (isPrivateMode) {
      store.commit("SET_COGNITO_USER_INFO", {});
      cognito.signout();
      next("/login");
    } else {
      next("/");
    }
  }
});

export default router;
